import { render, staticRenderFns } from "./CuentaShow.vue?vue&type=template&id=2d255375"
import script from "./CuentaShow.vue?vue&type=script&lang=js"
export * from "./CuentaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports